import { createContext } from 'react';

export const mainFrameRefContext = createContext<HTMLElement | null>(null);
